
import React from 'react'
import moment from 'moment'
import { momentCalendarConfig } from '../../../utils/baseStringUtils'
import EmptyCell from './EmptyCell'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import { type IMemberSummary } from '../../../interfaces/member-summary.interface'

export default function TemperatureCell (props: { memberObj: IMemberSummary }): JSX.Element {
  if (!props.memberObj.user.has_temperature || !props.memberObj.temperature) {
    return <EmptyCell message='No temperature data' />
  }

  const lastMeasurement = moment(props.memberObj.temperature.latest_measurement.timestamp)
  const latestCol = (
    <Box>
      <div className='member-row__latest'> {`${Math.round(props.memberObj.temperature.latest_measurement.temperature * 10) / 10}${props.memberObj.temperature.information.units.temperature as string}`} </div>
      <div className='member-row__latest-timestamp'> {lastMeasurement.calendar(null, momentCalendarConfig)} </div>
    </Box>
  )

  return (
    <Grid container>
      <Grid item xs={12}> {latestCol} </Grid>
    </Grid>
  )
}
